module.exports = __webpack_public_path__ + "img/arrow-right-edge.124824a3.svg";